import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICoinCouple, businessPlansNames } from 'constants/business-plan.constants';

interface IBusinessModelState {
	error: string | null;
	loading: boolean;
	businessPlans: any[] | null;
	coinsCouples: any[] | null;
	addNewCoinsCouple: boolean;
}

const initialState: IBusinessModelState = {
	error: null,
	loading: false,
	businessPlans: null,
	coinsCouples: null,
	addNewCoinsCouple: false,
};

export const businessModelSlice = createSlice({
	name: 'businessModel',
	initialState,
	reducers: {
		setError: (state, { payload }) => {
			state.error = payload;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setBusinessPlans: (state, { payload }) => {
			if (
				businessPlansNames.DEFAULT &&
				businessPlansNames.FREE &&
				businessPlansNames.BASIC &&
				businessPlansNames.PRO
			) {
				state.businessPlans = [
					payload?.find((item: any) => item.name === businessPlansNames.DEFAULT),
					payload?.find((item: any) => item.name === businessPlansNames.FREE),
					payload?.find((item: any) => item.name === businessPlansNames.BASIC),
					payload?.find((item: any) => item.name === businessPlansNames.PRO),
				];
			} else {
				state.businessPlans = payload?.sort((a: any, b: any) =>
					a.name > b.name ? 1 : b.name > a.name ? -1 : 0
				);
			}
		},
		setCoinsCouples: (state, { payload }) => {
			state.coinsCouples = payload;
		},
		addCoinsCouples: (state, action: PayloadAction<ICoinCouple[]>) => {
			if (state.coinsCouples) {
				state.coinsCouples = [...action.payload, ...state.coinsCouples];
			}
		},
		setAddNewCoinsCouple: (state, action: PayloadAction<boolean>) => {
			state.addNewCoinsCouple = action.payload;
		},
		updateBusinessPlanByIndex: (state, action: PayloadAction<any>) => {
			if (state.businessPlans) {
				state.businessPlans[action.payload.index] = action.payload.newModelPlan;
			}
		},
	},
});

export const getError = (state: any) => {
	return state.businessModel.error;
};

export const getBusinessPlans = (state: any) => {
	return state.businessModel.businessPlans;
};

export const getCoinsCouples = (state: any) => {
	return state.businessModel.coinsCouples;
};

export const getAddNewCoinsCouple = (state: any) => {
	return state.businessModel.addNewCoinsCouple;
};

export const isLoading = (state: any) => state.businessModel.loading;

export const {
	setError,
	setLoading,
	setBusinessPlans,
	setCoinsCouples,
	addCoinsCouples,
	setAddNewCoinsCouple,
	updateBusinessPlanByIndex,
} = businessModelSlice.actions;

export default businessModelSlice.reducer;
